import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=4ec20386&"
import script from "./ProfilePicture.vue?vue&type=script&lang=ts&"
export * from "./ProfilePicture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports